var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8132 9.81317C19.2623 9.36407 19.2623 8.63593 18.8132 8.18683L11.4946 0.868272C11.0455 0.419169 10.3174 0.419169 9.86827 0.868272C9.41917 1.31738 9.41917 2.04551 9.86827 2.49462L16.3737 9L9.86827 15.5054C9.41917 15.9545 9.41917 16.6826 9.86827 17.1317C10.3174 17.5808 11.0455 17.5808 11.4946 17.1317L18.8132 9.81317ZM0 10.15L18 10.15V7.85L0 7.85L0 10.15Z",
    fill: "white"
  })));
};
export default SvgRightArrow;